import React from 'react';
import { Button, cn } from '@mf-tools/domains-ui';
import { Container } from '../components';
import { scrollToId } from '../lib/scroll';

const OPEN_APP_URL = 'https://app.opspilott.com';

export interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <footer className={cn('border-t py-10', className)}>
      <Container>
        <div className="grid gap-8 md:grid-cols-3">
          <div className="space-y-2">
            <div className="text-base font-semibold text-foreground">OpsPilott</div>
            <div className="text-sm text-muted-foreground">Operations, on autopilot.</div>
          </div>

          <div className="grid gap-2 text-sm">
            <div className="font-medium text-foreground">Links</div>
            <div className="flex flex-col items-start gap-2 text-muted-foreground">
              <button type="button" className="hover:text-foreground" onClick={() => scrollToId('features')}>
                Product
              </button>
              <button type="button" className="hover:text-foreground" onClick={() => scrollToId('why')}>
                Why OpsPilott
              </button>
              <button type="button" className="hover:text-foreground" onClick={() => scrollToId('contact')}>
                Contact
              </button>
              <a className="hover:text-foreground" href={OPEN_APP_URL} target="_blank" rel="noreferrer">
                Open App
              </a>
            </div>
          </div>

          <div className="grid gap-2 text-sm">
            <div className="font-medium text-foreground">Legal</div>
            <div className="flex flex-col items-start gap-2 text-muted-foreground">
              <a className="hover:text-foreground" href="/privacy">
                Privacy Policy
              </a>
              <a className="hover:text-foreground" href="/terms">
                Terms
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col-reverse items-start justify-between gap-4 border-t pt-6 text-sm text-muted-foreground sm:flex-row sm:items-center">
          <div>© {year} OpsPilott. All rights reserved.</div>
          <Button asChild variant="secondary" size="sm">
            <a href={OPEN_APP_URL} target="_blank" rel="noreferrer">
              Open App
            </a>
          </Button>
        </div>
      </Container>
    </footer>
  );
}

